import { useEffect, useState } from "react";

// Internal Imports
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import { useAuth } from "../contexts/auth";
import { Rol } from "../interfaces/Rol";
import { getRolByUserID } from "../services/rol";



const useListRol = () => {

    // States
    const { user } = useAuth();
    const [listRol, setListRol] = useState<Rol[]>([]);
    const [loadingRols, setLoadingRols] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetRolsByUserID();
    }, [user])

    // Handles
    const handleGetRolsByUserID = () => {
        setLoadingRols(true);
        tryCatch(() => {
            getRolByUserID(user!.usuarioID)
                .then((response) => {
                    setListRol(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingRols(false));
        })
    }

    return {
        listRol,
        loadingRols
    }
}


export default useListRol;